export default function (resource_id, course_id, hasFields, hasCodes) {
  var self = this;
  self.$el = $('#js-resource-coupon-form');
  self.importingCoupons = ko.observableArray();
  self.csvFile = ko.observable().extend({required: true});
  self.hasFields = ko.observable();
  self.hasCodes = ko.observable();
  self.expires_at = ko.observable();
  self.can_expire = ko.observable();
  self.field = {
    label: ko.observable().extend({required: true}),
    required: ko.observable('no'),
    section: ko.observable(''),
    field_type: ko.observable('text')
  };
  self.fieldTypes = [
    {
      id: 'text',
      name: 'Text'
    },
    {
      id: 'yes_no',
      name: 'Yes / No'
    },
    {
      id: 'checkbox',
      name: 'Checkbox'
    },
    {
      id: 'ssn',
      name: 'SSN'
    }
  ];
  self.requiredOptions = [
    {value: 'no', label: 'No'},
    {value: 'transcript', label: 'Required For Transcript'},
    {value: 'access', label: 'Required For Course Access'},
    {value: 'enrollment', label: 'Required To Enroll'},
    {value: 'always', label: 'Always Required'},
  ];
  self.save = function(item, event) {
    if (self.hasCodes()) {
      self.saveCoupons();
    } else if (self.hasFields()) {
      self.saveField();
    }
  };

  self.saveCoupons = function(){
    var urlParams = {
      resource_id: resource_id,
      course_id: course_id
    };
    var url = Kadenze.Routes.bulk_upload_course_resource_resource_coupons_path(urlParams);
    var method = 'POST';
    var data = {
      codes: _.pluck(self.importingCoupons(), 'code'),
    };
    if (self.can_expire()) {
      data.redeem_by = moment(self.expires_at()).toString();
    }

    Kadenze.UIUtil.makeRequest(url, method, data, self.$el,
      function(xhr, settings) { //BeforeSave
        Kadenze.UIUtil.showLoadingIndicator(self.$el);
      },
      function(data, textStatus, xhr) { //Success
        var url = Kadenze.Routes.course_resource_resource_coupons_path(urlParams);
        Kadenze.Request.pjax({
          url: url,
          container: '#main-pjax-container'
        });
      },
      function(xhr, textStatus, errorThrown) { //Error
        Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
      },
      function(xhr, textStatus) { //Complete
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      });
  };

  self.initBulkUploader = function() {
    var dzOptions = {
      url: Kadenze.Routes.temp_spreadsheet_upload_path({
        headers: {
          code: 'code'
        }
      }),
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      maxFiles: 1,
      autoProcessQueue: true,
      acceptedFiles: '.csv,.xls,.xlsx',
      paramName: 'file',
      previewTemplate: '<span></span>',
      useKilobytes: true, // custom option added to dropzone. Contacting dev to see if they'll add this feature
      init: function() {
        this.on('sending', function(file, xhr, formData) {
          Kadenze.UIUtil.showLoadingIndicator(self.$el);
        });

        this.on('success', function(file, response) {
          if (response.data.length > 1) {
            var codes = response.data;
            codes.shift();
            var newCoupons = [];
            for (var i in codes) {
              var coupon = codes[i];
              if (coupon.code) {
                newCoupons.push(coupon);
              }
            }
            self.importingCoupons(newCoupons);
          } else {
            Kadenze.UIUtil.showNotice(self.$el, {status: 'error', message: Kadenze.I18n.t('resource_coupons.new.spreadsheet_empty')}, 5000);
          }
        });

        this.on('error', function(file, errorMessage) {
          Kadenze.UIUtil.showNotice(self.$el, {status: 'error', message: Kadenze.I18n.t('resource_coupons.new.spreadsheet_invalid')}, 5000);
        });

        this.on('complete', function(file) {
          Kadenze.UIUtil.hideLoadingIndicator(self.$el);
          this.removeAllFiles();
        });
      }
    };
    var dz = new Dropzone('#js-coupon-upload-link', dzOptions);
  };


  self.saveField = function(){
    if (!self.validate(true)) {
      return false;
    }
    var fieldJS = ko.mapping.toJS(self.field);
    var urlParams = {
      resource_id: resource_id,
      course_id: course_id
    };
    var url = resource_id ? Kadenze.Routes.course_resource_enrollment_fields_path(urlParams) :
      Kadenze.Routes.course_enrollment_fields_path(urlParams);
    var method = 'POST';
    var data = {
      enrollment_field: fieldJS
    };

    Kadenze.UIUtil.makeRequest(url, method, data, self.$el,
      function(xhr, settings) { //BeforeSave
        Kadenze.UIUtil.showLoadingIndicator(self.$el);
      },
      function(data, textStatus, xhr) { //Success
        var url = resource_id ? Kadenze.Routes.course_resource_enrollment_fields_path(urlParams) :
          Kadenze.Routes.course_enrollment_fields_path(urlParams);
        Kadenze.Request.pjax({
          url: url,
          container: '#main-pjax-container'
        });
      },
      function(xhr, textStatus, errorThrown) { //Error
        Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
      },
      function(xhr, textStatus) { //Complete
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      });
  };

  self.selectType = function(type) {
    return function() {
      self[type](true);
    };
  };

  self.initUI = function() {
    self.bindData(hasFields, hasCodes);
  };

  self.bindData = function(hasFields, hasCodes) {
    self.hasCodes.subscribe(function(hasCodes){
      if (hasCodes) {
        self.initBulkUploader();
      }
    });
    self.hasFields(hasFields);
    self.hasCodes(hasCodes);
  };

  self.canSubmit = function() {
    var hasCoupons = self.importingCoupons().length !== 0;
    return self.hasFields() || hasCoupons;
  };

  self.validate = function(showErrors) {
    self.clientErrors = ko.validation.group(self.field.label, { deep: true });
    if (self.clientErrors().length === 0 || (self.clientErrors().length === 1 && self.clientErrors()[0] === null)) {
      return true;
    } else {
      if (showErrors) {
        self.clientErrors.showAllMessages();
      }
      return false;
    }
  };

  const __construct = function(that) {
  }(this);
}
